import React from 'react';
import track from 'react-tracking';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import { CTA } from '../elog/mparticle_tracker';
import { withUserContext, IUserContext } from './user_context_provider';
import { isExperimentEnabled } from '../user_context_helpers';
import experiments from '../experiments';
import {
  ListingsCollection,
  ExternalProps as IListingCollectionProps,
} from './listings_collection';

import {
  CommonsWatchedListings,
} from '../rql';

import CoreLink from './core_link';
import withListings from '../with_listings';

const COMPONENT_NAME = 'WatchRow';
const MAX_COUNT = 12;
const MIN_COUNT = 4;

type IProps = IListingCollectionProps & IUserContext;

const WatchedListings = withUserContext(withListings<CommonsWatchedListings.Query, CommonsWatchedListings.Variables, IProps>({
  query: gql`
    query Commons_WatchedListings(
      $limit: Int,
      $showListingLocation: Boolean!
    ) {
      me {
        uuid
        watches(input: {
          limit: $limit
          listingsState: LIVE
        }) {
          nodes {
            _id
            listing {
              _id
              ... ListingsCollection
              ... ShopFields @include(if: $showListingLocation)
            }
          }
        }
      }
    }
    ${ListingsCollection.fragments.listing}
    ${ListingsCollection.fragments.shopFields}
  `,
  options: ownProps => ({
    skip: !!ownProps.user?.loggedOut,
    variables: {
      limit: MAX_COUNT,
      showListingLocation: isExperimentEnabled(ownProps.user, experiments.LISTING_CARD_LOCATION),
    },
  }),
  extractListings: (data) => {
    return (
      data.me?.watches?.nodes ?? []
    ).map(n => n.listing);
  },
  shouldRender: (data) => {
    if (data.loading) {
      return false;
    }

    const listings = data.me?.watches?.nodes ?? [];
    return listings.length >= MIN_COUNT;
  },
  buildDefaultProps: () => {
    return {
      callToAction: (
        <CoreLink
          to="/watched_products"
          interactionType={CTA}
        >
          {I18n.t('commons.watchRow.cta')}
        </CoreLink>
      ),
      componentName: COMPONENT_NAME,
      title: I18n.t('commons.watchRow.title'),
      largeTiles: true,
    };
  },
}));

export default track({ componentName: COMPONENT_NAME })(WatchedListings);
